module.exports = __webpack_public_path__ + "static/media/numAscending.39f7c689.svg";